import React from 'react';
import { PatientCard } from './PatientCard';
import { PrimaryButton } from './PrimaryButton';
import { teaserPatients } from '../../data/teaser';
type HookScreenProps = {
  onAnswer: (answer: 'yes' | 'no') => void;
};
export function HookScreen({
  onAnswer
}: HookScreenProps) {
  return <div className="flex h-full flex-col" data-id="element-130" data-mp="38il94sjhg68q">
      <h1 className="text-[30px] font-semibold leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-131" data-mp="38hjmrrx0nxbp">
        Same goal.
        <br data-id="element-132" data-mp="3ne98a39y235r" />
        Same starting approach?
      </h1>
      <p className="mt-3 text-[15px] leading-snug text-graphite" data-id="element-133" data-mp="3ii2bazzj01zy">
        Two patients. Different ovarian reserve. Different body weight.
      </p>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-134" data-mp="5dvi013km3k">
        {teaserPatients.map(p => <PatientCard key={p.id} patient={p} data-id="element-135" data-mp="3s96r21x0zqvu" />)}
      </div>

      <div className="mt-auto pt-6" data-id="element-136" data-mp="a28vyogxkwkh">
        <p className="mb-2 flex items-center justify-center gap-1.5 font-mono text-[10px] tracking-[0.18em] text-accent" data-id="element-137" data-mp="9z4jl3tbauiq">
          <span className="snak-dot h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" data-id="element-138" data-mp="29tsz14sp9cyd" />
          CLICK TO ENGAGE
        </p>
        <p className="text-center text-[17px] font-medium tracking-[-0.01em] text-ink" data-id="element-139" data-mp="2etp0awa0iqa8">Would you approach them the same way?</p>
        <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-140" data-mp="2jqfipq9ahxyt">
          {(['yes', 'no'] as const).map((a, i) => <div key={a} className="snak-nudge rounded-full" style={{
          animationDelay: `${0.3 + i * 0.2}s`
        }} data-id="element-141" data-mp="2nr7sqlpzk6w5" data-mpi={i}>
              <PrimaryButton variant="outline" onClick={() => onAnswer(a)} data-id="element-142" data-mp="2sqkmzrj6sg8r">
                {a.toUpperCase()}
              </PrimaryButton>
            </div>)}
        </div>
      </div>
    </div>;
}